import { SravniQuizModelsFiltersVotePutModel, VotesGetDataForUserListParams } from '../__generated__/quiz/Api';
import { NormalizedVoteWithPercentOptions } from '../server/services/quiz';

import { ProxyClient } from './client/ProxyClient';

export const getQuizForUser = async (
  params: VotesGetDataForUserListParams,
): Promise<NormalizedVoteWithPercentOptions> => {
  const { data } = await ProxyClient.get<NormalizedVoteWithPercentOptions>('/survey/get-for-user', { params });

  return data;
};

export const addVote = async (
  params: SravniQuizModelsFiltersVotePutModel,
): Promise<NormalizedVoteWithPercentOptions> => {
  const { data } = await ProxyClient.put<NormalizedVoteWithPercentOptions>('/survey/add-vote', params);

  return data;
};
